module.exports = __webpack_public_path__ + "img/login.a5a27c0c.png";